var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styleDiv),attrs:{"id":"container"}},[_c('img',{ref:"elementImage",style:(_vm.styleImg),attrs:{"alt":"Images","src":_vm.getImageByID(_vm.id)}})])}
var staticRenderFns = []

export { render, staticRenderFns }